import React from "react";
export const useCountdown = (countdownValue = 5, onClick) => {
  const [timer, setTimer] = React.useState(countdownValue);
  let decrementTimer;
  React.useEffect(() => {
    return () => {
      clearTimeout(decrementTimer);
    };
  }, []);
  React.useEffect(() => {
    if (timer === 0) {
      onClick();
    } else {
      decrementTimer = setTimeout(() => setTimer(timer - 1), 1000);
    }
  }, [timer]);
  return {
    timer
  };
};